import '/app/brewery-packages/content/content-editor-plugin-list-item/src/ListItem.css-raw';
export default {
  "listItem": "cover-letter-traditional-173018a8-listItem-zUCuRq"
};